import { useCallback, useRef } from 'react'
import { useNavigate, type NavigateFunction } from 'react-router-dom'
import { type NotificationResponseDto } from '@fp3/shared'

type ShowFn = (n: NotificationResponseDto) => void

export const useBrowserNotifications = (): ShowFn => {
  const navigate = useNavigate()
  const permissionRequested = useRef(false)

  return useCallback(
    (n: NotificationResponseDto) => {
      if (!('Notification' in window)) return

      if (Notification.permission === 'default' && !permissionRequested.current) {
        permissionRequested.current = true
        void Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            fireNotification(n, navigate)
          }
        })
        return
      }

      if (Notification.permission === 'granted') {
        fireNotification(n, navigate)
      }
    },
    [navigate, permissionRequested]
  )
}

function fireNotification(n: NotificationResponseDto, navigate: NavigateFunction): void {
  const notification = new Notification(n.title, {
    body: n.message,
    icon: '/vectorFP3Logo.svg',
    tag: n.id,
  })
  notification.onclick = () => {
    window.focus()
    const target = n.link ?? '/profile/notifications'
    // only allow relative paths — reject absolute URLs (scheme:// and protocol-relative //)
    if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(target) || target.startsWith('//')) return
    navigate(target)
  }
}
